
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabandbusserviceinbaner() {



    const cardData =
    {
        keyword: 'Cab and Bus Services in Baner',
        heading: 'etravo : Cab and Bus Services in Baner',
        headingDescription: 'eTravo provides dependable Cab and Bus Services in Baner, catering to the dynamic transportation needs of corporate offices, tech parks, and residential communities in the area. Whether it’s on-demand cabs for executives, airport transfers, or scheduled buses for employee commute, our services are crafted for comfort, punctuality, and safety. With GPS-enabled vehicles, professional chauffeurs, and a dedicated support team, eTravo ensures smooth mobility solutions in and around Baner. From small businesses to large enterprises, we deliver efficient and customized transport services to keep your operations moving effortlessly.',

        top: 'Top Places to Visit in Pune with etravo',
         "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fortification in Pune. Though much of it was destroyed in an 1828 fire, the surviving structures and gardens offer a glimpse into its grand past. The site is renowned for its architectural features and is a popular tourist attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892 by Sultan Muhammed Shah Aga Khan III, this palace played a significant role during India's freedom movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace now houses a museum and memorials dedicated to Gandhi and his associates."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located approximately 28 km southwest of Pune, Sinhagad Fort is a hill fortress known for the Battle of Sinhagad in 1670. The fort offers panoramic views and is a popular destination for trekking enthusiasts. It houses memorials and remnants of historical significance."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This renowned temple is dedicated to Lord Ganesha and is famous for its rich history and the grand idol adorned with gold. It attracts thousands of devotees, especially during the Ganesh Chaturthi festival."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is carved from a single basalt rock. The temple complex includes a circular Nandi mandapa and is a protected monument under the Archaeological Survey of India."
    },
    {
      "title": "Osho International Meditation Resort",
      "description": "Situated in Koregaon Park, this meditation center offers a tranquil environment for spiritual growth and wellness. It attracts visitors worldwide seeking meditation and personal development programs."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped garden symbolizes the Indo-Japanese friendship. It features manicured lawns, waterfalls, and a serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of artifacts showcasing India's rich cultural heritage. Exhibits include musical instruments, sculptures, and everyday objects from the 18th and 19th centuries."
    },
    {
      "title": "Koregaon Park",
      "description": "A vibrant neighborhood known for its lush greenery, upscale eateries, and cultural hubs. Koregaon Park is a popular destination for dining, shopping, and experiencing Pune's cosmopolitan lifestyle."
    },
    {
      "title": "Lal Mahal",
      "description": "Originally built in the 17th century, Lal Mahal is historically significant as the childhood residence of Chhatrapati Shivaji Maharaj. The reconstructed palace now serves as a museum showcasing Maratha history."
    }
  ],



 "services": [
  {
    "name": "Cab and Bus Services in Baner",
    "description": "eTravo provides reliable cab and bus services in Baner, Pune, for corporate travel, staff commutes, and business events. Our fleet ensures safe and timely transportation, covering Baner and nearby IT hubs."
  },
  {
    "name": "Employee Transport Services Baner",
    "description": "Simplify daily staff travel with eTravo’s employee transport services in Baner. We cover all key pickup and drop points in Baner and surrounding areas, using well-maintained buses and cabs for efficient employee commutes."
  },
  {
    "name": "Corporate Cab Services Baner Pune",
    "description": "eTravo offers dedicated corporate cab services in Baner, Pune, designed for executive and staff travel. Our professional chauffeurs and premium vehicles ensure punctuality, comfort, and complete professionalism."
  },
  {
    "name": "Affordable Employee Transport Baner",
    "description": "eTravo delivers affordable employee transport services in Baner without compromising on safety or quality. Ideal for startups and growing companies, our cab and bus options are budget-friendly and reliable."
  },
  {
    "name": "AC Staff Bus Hire Baner",
    "description": "Choose eTravo for AC staff bus hire in Baner. Our air-conditioned buses offer a comfortable and cost-effective solution for employee transport, shift-based operations, and project site transfers in Baner and nearby zones."
  },
  {
    "name": "Corporate Shuttle Services Baner Pune",
    "description": "eTravo’s corporate shuttle services in Baner, Pune, are tailored for companies needing dedicated routes and schedules. Our shuttle solutions reduce absenteeism and improve on-time attendance across offices in the Baner region."
  },
  {
    "name": "Car and Bus Rentals for Companies Baner",
    "description": "eTravo provides flexible car and bus rentals for companies in Baner. Whether it’s daily employee travel, event logistics, or executive movement, our fleet is available on daily, weekly, or monthly plans to suit your needs."
  },
  {
    "name": "Staff Pickup and Drop Baner Pune",
    "description": "eTravo offers dependable staff pickup and drop services in Baner, Pune. Our optimized routing and real-time tracking help companies manage shift-based operations and ensure hassle-free employee transport every day."
  },
  {
    "name": "Customized Mobility Plans Baner",
    "description": "Get tailored employee commute solutions with eTravo’s customized mobility plans in Baner. Designed around your shift schedules, office locations, and employee clusters, our plans boost operational efficiency."
  },
  {
    "name": "Business Meeting Cabs Baner",
    "description": "eTravo provides business meeting cabs in Baner for corporate professionals. Book clean, comfortable, and punctual executive cabs for one-time meetings, client visits, or regular office travel with ease."
  },
  {
    "name": "Executive Transport Services Baner",
    "description": "Travel in comfort and style with eTravo’s executive transport services in Baner. Our premium cars and trained chauffeurs cater to senior staff, CXOs, and clients for transfers, meetings, and conferences across Pune."
  },
  {
    "name": "End-to-End Corporate Mobility Baner",
    "description": "From planning to implementation, eTravo delivers end-to-end corporate mobility solutions in Baner. We manage everything from employee pickups and executive travel to shuttle services and real-time monitoring."
  },
  {
    "name": "Corporate Commute Services Baner Pune",
    "description": "eTravo’s corporate commute services in Baner, Pune, ensure that your employees reach their workplace safely and on time. With scalable solutions, we support both small and large corporate mobility needs."
  },
  {
    "name": "Reliable Employee Transport Baner",
    "description": "Count on eTravo for reliable employee transport in Baner. We use GPS-enabled vehicles, experienced drivers, and efficient routes to provide consistent, timely commute services for businesses of all sizes."
  },
  {
    "name": "Monthly Cab Rentals for Staff Baner",
    "description": "eTravo offers flexible and affordable monthly cab rentals for staff in Baner. Ideal for companies looking to streamline transportation budgeting, with fixed pricing, regular schedules, and dependable service."
  }
],
"tableData": [
  ["Cab and Bus Services in Baner", "Employee Transport Services Baner"],
  ["Corporate Cab Services Baner Pune", "Affordable Employee Transport Baner"],
  ["AC Staff Bus Hire Baner", "Corporate Shuttle Services Baner Pune"],
  ["Car and Bus Rentals for Companies Baner", "Staff Pickup and Drop Baner Pune"],
  ["Customized Mobility Plans Baner", "Business Meeting Cabs Baner"],
  ["Executive Transport Services Baner", "End-to-End Corporate Mobility Baner"],
  ["Corporate Commute Services Baner Pune", "Reliable Employee Transport Baner"],
  ["Monthly Cab Rentals for Staff Baner", ""]
],






"whychoose": [
    {
        "WhyChooseheading": "Specialized Cab and Bus Services in Baner",
        "WhyChoosedescription": "As one of Pune’s fastest-growing business districts, Baner demands efficient and flexible transport solutions. eTravo offers premium cab and bus services designed to serve corporate offices, startups, and commercial centers with punctual and professional mobility options."
    },
    {
        "WhyChooseheading": "Versatile Fleet for Business and Daily Commutes",
        "WhyChoosedescription": "Our Baner fleet includes hatchbacks, sedans, SUVs, tempo travellers, and large AC buses—ready to serve a variety of travel needs from employee pick-ups and drop-offs to VIP transfers and team outings."
    },
    {
        "WhyChooseheading": "Timely Services with Route Optimization",
        "WhyChoosedescription": "eTravo’s operations team ensures your rides are on schedule, even during Baner’s peak traffic hours. Our route-optimized services reduce delays and improve commute efficiency across connected areas like Aundh, Balewadi, and Hinjewadi."
    },
    {
        "WhyChooseheading": "Trained Drivers with Local Expertise",
        "WhyChoosedescription": "Our drivers are background-verified, uniformed, and familiar with the Baner area and surrounding tech corridors. Their local knowledge ensures smoother and safer travel, especially for time-sensitive business trips."
    },
    {
        "WhyChooseheading": "Flexible Packages for Businesses in Baner",
        "WhyChoosedescription": "Whether you're running a small startup or a large enterprise in Baner, eTravo provides scalable cab and bus service packages tailored to your needs—from regular office shuttles to event-day logistics."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Corporate Billing",
        "WhyChoosedescription": "We offer upfront pricing with no hidden charges. Our invoicing is GST-compliant, and we provide monthly statements—making it easier for your finance and admin teams to manage transportation expenses."
    },
    {
        "WhyChooseheading": "Hygienic, Safe, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Every eTravo vehicle in Baner is cleaned regularly and comes equipped with GPS tracking, seat belts, first aid kits, and fire safety tools—ensuring a secure and comfortable journey for all passengers."
    },
    {
        "WhyChooseheading": "Real-Time Support and Ride Monitoring",
        "WhyChoosedescription": "Track your rides live and get support 24/7 from our Baner-focused operations team. We coordinate closely with your HR and admin teams to ensure dependable, round-the-clock service management."
    }
]







































    }

const faqData = [
    [
        {
            question: 'What cab and bus services does eTravo offer in Baner?',
            answer: 'eTravo provides reliable cab and bus services in Baner, including corporate travel, employee transport, executive transfers, and event transportation with flexible booking options.',
        },
        {
            question: 'Can eTravo support corporate travel needs in Baner?',
            answer: 'Yes, eTravo caters to corporate clients in Baner with services such as employee pick-up and drop, client visits, and multi-point routing for seamless business travel.',
        },
        {
            question: 'What types of vehicles are available for hire in Baner?',
            answer: 'Our fleet in Baner includes hatchbacks, sedans, SUVs, tempo travellers, and AC buses (13–50 seaters), all well-maintained for comfort, safety, and punctuality.',
        },
        {
            question: 'Does eTravo provide GPS tracking and safety measures in Baner?',
            answer: 'Yes, all vehicles are equipped with real-time GPS tracking, driver verification, digital logs, and route compliance to ensure a safe and transparent travel experience.',
        },
        {
            question: 'Is there dedicated support for corporate clients in Baner?',
            answer: 'Every corporate client in Baner gets a dedicated account manager to assist with scheduling, operations, and issue resolution for cab and bus services.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Aditya Joshi',
        designation: 'Admin Head, Innovatech Solutions, Baner',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s cab and bus services in Baner have made our corporate travel effortless. The vehicles are comfortable, and the team is always punctual and professional.”',
    },
    {
        name: 'Ms. Kavya Desai',
        designation: 'HR Manager, Nexa Industries, Baner',
        rating: [1, 1, 1, 1, 1],
        text: '“Using eTravo for employee transport and client visits in Baner has been a great decision. Their real-time tracking and reliable service make daily commutes stress-free.”',
    },
];













    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab and Bus Services in Baner",
  "image": "https://www.etravo.in/images/keyword/cab-bus-baner.jpg",
  "description": "Affordable cab and bus services in Baner offering employee transport, corporate shuttle services, AC staff bus hire, and customized mobility plans for businesses and corporate commute solutions.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-and-bus-services-in-baner"
  }
};





    return (
        <div>
<Helmet>
  <title>Cab and Bus Services in Baner | Corporate Employee Transport & Shuttle Services | eTravo</title>
  <meta 
    name="description" 
    content="Affordable cab and bus services in Baner by eTravo. Employee transport, corporate shuttle, AC staff bus hire, and monthly cab rentals for reliable corporate mobility solutions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/7.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabandbusserviceinbaner;